import { useLazyFetchV2 } from "hooks/fetch/useLazyFetchV2";

/**
 * Provides a callback function which can be used to post to the url passed in
 * @param url the url to post to
 * @returns {{loading: boolean, error: boolean, postCallback: ((function(*=, *=): Promise<*>))}}
 *
 * loading - true when post is currently happening.
 *
 * error - true when an error has occured.
 *
 * postCallback - the post callback function, takes a body object and returns an abort function and a response promise
 */
export function useFetchPostV2(url) {
  const { loading, error, fetchCallback } = useLazyFetchV2("POST");

  return {
    loading,
    error,
    postCallback: (body, headers = { "Content-Type": "application/json" }) =>
      fetchCallback(url, body, headers)
  };
}
